/**
 * Static decoy SVG placeholder for screenshots when break-glass is inactive.
 *
 * NOTE (0d-F3): BLURRED_SCREENSHOT_PLACEHOLDER is deliberately a static decoy SVG,
 * NOT a blur of the real screenshot. Even a heavy blur leaks layout, color palette,
 * and recognizable shapes that could identify user surfaces or sensitive customer data.
 * The deliberate trade-off is zero triage signal from the thumbnail, requiring explicit
 * break-glass reveal for every screenshot.
 */
export const BLURRED_SCREENSHOT_PLACEHOLDER =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400" viewBox="0 0 600 400"><defs><filter id="b"><feGaussianBlur stdDeviation="16"/></filter></defs><rect width="600" height="400" fill="%231e2229"/><g filter="url(%23b)"><rect x="40" y="40" width="520" height="80" rx="10" fill="%23303643"/><rect x="40" y="140" width="240" height="200" rx="10" fill="%233a4150"/><rect x="300" y="140" width="260" height="90" rx="10" fill="%232b313d"/><rect x="300" y="250" width="260" height="90" rx="10" fill="%232b313d"/></g><text x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="%23e6edf3" font-family="system-ui, sans-serif" font-size="16" font-weight="600">🔒 Content hidden by default — Break-glass required</text></svg>'

const JWT_REGEX = /eyJ[a-zA-Z0-9_-]{6,}\.eyJ[a-zA-Z0-9_-]{6,}\.[a-zA-Z0-9_-]*/g
const API_KEY_REGEX = /(?:sk_live_|sk_test_|pk_live_|key-[0-9a-f]{16,}|ghp_[a-zA-Z0-9]{20,})[a-zA-Z0-9_-]*/g
const BEARER_TOKEN_REGEX = /(Bearer\s+)[a-zA-Z0-9_\-.]{20,}/gi
const COOKIE_REGEX = /(?:__session|connect\.sid|sessionid|authToken|auth_token|id_token)=([a-zA-Z0-9_%-]{10,})/gi
const SESSION_URL_REGEX = /https?:\/\/[^\s"']+[?&](?:token|session|auth_token|access_token|secret)=[^&\s"']+[^\s"']*/gi
const CONTENT_PATH_REGEX = /\bworkspaces\/[a-zA-Z0-9_-]{15,}\/(?:channels|checklists|timeline|forms)(?:\/[^\s"']*)?/g

export const scrubSecrets = (text: string): string => {
  if (!text || typeof text !== 'string') return ''
  return text
    .replace(JWT_REGEX, '[redacted jwt]')
    .replace(API_KEY_REGEX, '[redacted api-key]')
    .replace(BEARER_TOKEN_REGEX, '$1[redacted bearer-token]')
    .replace(COOKIE_REGEX, '__session=[redacted cookie]')
    .replace(SESSION_URL_REGEX, '[redacted session url]')
}

export const maskContentPaths = (text: string): string => {
  if (!text || typeof text !== 'string') return ''
  return text.replace(CONTENT_PATH_REGEX, '[redacted content ref]')
}

export const redactTextBundle = (text: string): string => {
  return scrubSecrets(maskContentPaths(text))
}
